import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';

const OrderGroupCell = ({ rowData }) => {
	const sub_value = rowData.sub_value;

	if (rowData.id === 'weight') {
		return (
			<span>
				<b className="order-group-cell__bold">Коэффициент утилизации:</b>{' '}
				{sub_value !== null && sub_value !== undefined ? sub_value : '---'}
			</span>
		);
	}
	if (rowData.id === 'volume') {
		return (
			<span>
				<b className="order-group-cell__bold">Коэффициент утилизации:</b>{' '}
				{sub_value !== null && sub_value !== undefined ? sub_value : '---'}
			</span>
		);
	}
	if (rowData.id.includes('compatibilities_')) {
		return (
			<span>
				<b className="order-group-cell__bold">Совместим с:</b>{' '}
				{sub_value !== null && sub_value !== undefined ? sub_value : '---'}
			</span>
		);
	}

	return null;
};

OrderGroupCell.propTypes = {
	rowData: PropTypes.shape({
		id: PropTypes.string.isRequired,
		sub_value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	}).isRequired,
	columnId: PropTypes.string.isRequired,
};

export { OrderGroupCell };
